var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.175 82.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.922,15.5a7.751,7.751,0,1,0-7.751-7.751A7.751,7.751,0,0,0,43.922,15.5ZM18.359,51.265l-2.39,5.574H5.167a5.167,5.167,0,0,0,0,10.335H17.674a7.735,7.735,0,0,0,7.123-4.7l1.419-3.314-1.723-1.017A15.377,15.377,0,0,1,18.359,51.265Zm43.65-15.1H54.9l-4.208-8.6a15.5,15.5,0,0,0-9.976-8.226L29.236,15.932A15.436,15.436,0,0,0,16.182,18.7L9.776,23.61a5.167,5.167,0,0,0,6.288,8.2L22.473,26.9a5.028,5.028,0,0,1,4.081-.991l2.374.706L22.878,40.725a10.362,10.362,0,0,0,4.247,12.968l13.723,8.1L36.412,75.962a5.167,5.167,0,1,0,9.862,3.087L51.383,62.73a7.783,7.783,0,0,0-3.494-8.783L38,48.111l5.056-12.641,3.273,6.69A7.8,7.8,0,0,0,53.29,46.5h8.718a5.167,5.167,0,1,0,0-10.333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.c8e98fba.svg";
export { ForwardRef as ReactComponent };